/**
 * « GO ! » d'une séance du masteur, sur l'accueil comme dans la semaine — l'ancien bouton de chaque
 * carte (`TutorLiveCardComponent`) :
 *  - le jour du live → `pre-call` sur CETTE séance, qu'elle vienne, ait commencé ou soit passée ;
 *  - un autre jour → la boîte « Le live n'est accessible que le jour même » (`notTodaySession`, que
 *    la page passe à `<LiveAccessDialog>`), qui dit quel jour revenir.
 * Le jour se lit au moment du geste : une page restée ouverte passé minuit fait entrer le bon jour.
 */
import { useNavigation } from "@react-navigation/native"
import { useCallback, useState } from "react"

import { isToday } from "../../../formatters/dateFormatter"

type PushNavigation = { push: (route: string, params?: object) => void }

/** Une séance qu'on rejoint : son id (celui du précall) et sa date. */
type JoinableSession = { id: number | string; date: string }

export function useTutorJoinSession<S extends JoinableSession>() {
    const navigation = useNavigation() as unknown as PushNavigation
    const [notTodaySession, setNotTodaySession] = useState<S | null>(null)

    const onJoinSession = useCallback(
        (session: S) => {
            if (isToday(session.date)) navigation.push("pre-call", { liveSessionId: session.id })
            else setNotTodaySession(session)
        },
        [navigation]
    )
    const onCloseNotToday = useCallback(() => setNotTodaySession(null), [])

    return { onJoinSession, notTodaySession, onCloseNotToday }
}
